import Fab from '@material-ui/core/Fab';
import { SvgIcon, SvgIconProps } from '@material-ui/core';
import { iconPaths, IconTypes } from '../../../react/constants/icons';
import React from 'react';

type FabButtonTypes = {
	icon: IconTypes;
	className?: string;
	svgIconProps: SvgIconProps;
    ariaLabel: string;
    title?: string;
	href?: string;
	onClick?: () => void;
};

const FabButton: React.FC<FabButtonTypes> = ({ icon, svgIconProps, ariaLabel,title, ...props }) => {
	return (
		<Fab size="small" color="primary" aria-label={ariaLabel} title={title} {...props}>
			<SvgIcon {...svgIconProps}>
				<path d={iconPaths[icon]} />
			</SvgIcon>
		</Fab>
	);
};

export default FabButton;

FabButton.defaultProps = {
	icon: 'search',
};
